import React, { useState, useEffect } from "react";

export default function TableAdmin({ table }) {
  const [rows, setRows] = useState([]);
  const [editingRowId, setEditingRowId] = useState(null);
  const [formData, setFormData] = useState({});
  const [newRowData, setNewRowData] = useState({});

  // Fetch table data
  const fetchRows = async () => {
    const res = await fetch(process.env.REACT_APP_BACKEND_URL+`/${table}`);
    const data = await res.json();
    setRows(data);
  };

  useEffect(() => {
    fetchRows();
  }, [table]);

  // Start editing a row
  const startEdit = (row) => {
    setEditingRowId(row.id);
    setFormData(row);
  };

  // Cancel editing
  const cancelEdit = () => {
    setEditingRowId(null);
    setFormData({});
  };

  // Handle input change
  const handleChange = (field, value, isNew = false) => {
    if (isNew) {
      setNewRowData(prev => ({ ...prev, [field]: value }));
    } else {
      setFormData(prev => ({ ...prev, [field]: value }));
    }
  };

  // Save edited row
  const saveRow = async (rowData) => {
    const res = await fetch(process.env.REACT_APP_BACKEND_URL+`/${table}/${rowData.id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(rowData),
    });
    if (res.ok) {
      setEditingRowId(null);
      fetchRows();
    } else {
      alert("Update failed");
    }
  };

  // Delete row
  const deleteRow = async (id) => {
    if (!window.confirm("Are you sure you want to delete this row?")) return;
    const res = await fetch(process.env.REACT_APP_BACKEND_URL+`/${table}/${id}`, {
      method: "DELETE",
    });
    if (res.ok) {
      fetchRows();
    } else {
      alert("Delete failed");
    }
  };

  // Add new row
  const addRow = async () => {
    const res = await fetch(process.env.REACT_APP_BACKEND_URL+`/${table}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(newRowData),
    });
    if (res.ok) {
      setNewRowData({});
      fetchRows();
    } else {
      alert("Failed to add row");
    }
  };

  if (!rows.length) return <p>Loading {table}...</p>;

  const headers = Object.keys(rows[0]);

  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">{table}</h2>

      {/* Table */}
      <table className="table-auto border w-full mb-4">
        <thead>
          <tr className="bg-gray-200">
            {headers.map(h => <th key={h} className="border px-2">{h}</th>)}
            <th className="border px-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.id}>
              {headers.map((field) => (
                <td key={field} className="border px-2">
                  {editingRowId === row.id ? (
                    <input
                      value={formData[field]}
                      onChange={(e) => handleChange(field, e.target.value)}
                      className="border p-1 w-full"
                    />
                  ) : (
                    row[field]
                  )}
                </td>
              ))}
              <td className="border px-2">
                {editingRowId === row.id ? (
                  <>
                    <button onClick={() => saveRow(formData)} className="mr-2 p-1 bg-green-500 text-white rounded">Save</button>
                    <button onClick={cancelEdit} className="p-1 bg-gray-400 text-white rounded">Cancel</button>
                  </>
                ) : (
                  <>
                    <button onClick={() => startEdit(row)} className="mr-2 p-1 bg-blue-500 text-white rounded">Edit</button>
                    <button onClick={() => deleteRow(row.id)} className="p-1 bg-red-500 text-white rounded">Delete</button>
                  </>
                )}
              </td>
            </tr>
          ))}

          {/* New Row Input */}
          <tr className="bg-gray-100">
            {headers.map((field) => (
              <td key={field} className="border px-2">
                <input
                  value={newRowData[field] || ""}
                  onChange={(e) => handleChange(field, e.target.value, true)}
                  className="border p-1 w-full"
                  placeholder={field}
                />
              </td>
            ))}
            <td className="border px-2">
              <button onClick={addRow} className="p-1 bg-green-500 text-white rounded">Add</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
